var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_5580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99951 17.1304C2.99951 15.5391 3.63165 14.0129 4.75687 12.8877C5.88209 11.7625 7.40821 11.1304 8.99951 11.1304C10.5908 11.1304 12.1169 11.7625 13.2422 12.8877C14.3674 14.0129 14.9995 15.5391 14.9995 17.1304H13.4995C13.4995 15.9369 13.0254 14.7923 12.1815 13.9484C11.3376 13.1045 10.193 12.6304 8.99951 12.6304C7.80604 12.6304 6.66144 13.1045 5.81753 13.9484C4.97362 14.7923 4.49951 15.9369 4.49951 17.1304H2.99951ZM8.99951 10.3804C6.51326 10.3804 4.49951 8.36662 4.49951 5.88037C4.49951 3.39412 6.51326 1.38037 8.99951 1.38037C11.4858 1.38037 13.4995 3.39412 13.4995 5.88037C13.4995 8.36662 11.4858 10.3804 8.99951 10.3804ZM8.99951 8.88037C10.657 8.88037 11.9995 7.53787 11.9995 5.88037C11.9995 4.22287 10.657 2.88037 8.99951 2.88037C7.34201 2.88037 5.99951 4.22287 5.99951 5.88037C5.99951 7.53787 7.34201 8.88037 8.99951 8.88037Z",
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_5580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.630615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserSolid);
export default __webpack_public_path__ + "static/media/icon_user_solid.e7bdb85aed174c89fe93b9b061695b55.svg";
export { ForwardRef as ReactComponent };